var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaused(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33337 5.83398C3.33337 4.65548 3.33337 4.06622 3.69949 3.7001C4.06561 3.33398 4.65487 3.33398 5.83337 3.33398C7.01188 3.33398 7.60114 3.33398 7.96726 3.7001C8.33337 4.06622 8.33337 4.65548 8.33337 5.83398V14.1673C8.33337 15.3458 8.33337 15.9351 7.96726 16.3012C7.60114 16.6673 7.01188 16.6673 5.83337 16.6673C4.65487 16.6673 4.06561 16.6673 3.69949 16.3012C3.33337 15.9351 3.33337 15.3458 3.33337 14.1673V5.83398Z",
    stroke: "white",
    strokeWidth: 1.67
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 5.83398C11.6667 4.65548 11.6667 4.06622 12.0328 3.7001C12.3989 3.33398 12.9882 3.33398 14.1667 3.33398C15.3452 3.33398 15.9344 3.33398 16.3006 3.7001C16.6667 4.06622 16.6667 4.65548 16.6667 5.83398V14.1673C16.6667 15.3458 16.6667 15.9351 16.3006 16.3012C15.9344 16.6673 15.3452 16.6673 14.1667 16.6673C12.9882 16.6673 12.3989 16.6673 12.0328 16.3012C11.6667 15.9351 11.6667 15.3458 11.6667 14.1673V5.83398Z",
    stroke: "white",
    strokeWidth: 1.67
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaused);
export default __webpack_public_path__ + "static/media/paused.7990af2455de43bac1053123ef30f89d.svg";
export { ForwardRef as ReactComponent };